import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=5c5317be&"
import script from "./Delegates.vue?vue&type=script&lang=ts&"
export * from "./Delegates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports